/* eslint-disable @typescript-eslint/no-use-before-define */
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { ERequestType, Stop } from "generated/graphql";
import React from "react";

const MapService: any = { current: null };
const DirectionRenderService: any = { current: null };
const DirectionService: any = { current: null };

export const icon = (url: string, widthAndHeight: any, originPoint: any, anchorPoint: any) =>
  new (window as any).google.maps.MarkerImage(
    // URL
    url,
    // (width,height)
    widthAndHeight,
    // The origin point (x,y)
    originPoint,
    // The anchor point (x,y)
    anchorPoint
  )

const icons = () => {
  const widthAndHeight = new (window as any).google.maps.Size(44, 32);
  const originPoint = new (window as any).google.maps.Point(0, 0);
  const anchorPoint = new (window as any).google.maps.Point(22, 32);
  return {
    start: icon("/assets/icons/deleveryIcon.svg", widthAndHeight, originPoint, anchorPoint),

    end: icon("/assets/icons/pickupIcon.svg", widthAndHeight, originPoint, anchorPoint),

    pickupNT: icon("/assets/icons/pickupNT.svg", widthAndHeight, originPoint, anchorPoint),

    deleveryNT: icon("/assets/icons/deleveryNT.svg", widthAndHeight, originPoint, anchorPoint),

    pd: icon("/assets/icons/pd.svg", widthAndHeight, originPoint, anchorPoint),
  }
};

export interface GoogleMapProps {
  id: string;
  options?: {};
  onMapLoad?: (map: any) => void;
  orgin?: any;
  destination?: any;
  travelMode?: string;
  height?: number | string;
  width?: string;
  stops?: Stop[];
  taskType?: string
}

const useStyles = makeStyles<Theme, { height?: number | string, width?: string }>(() =>
  createStyles({
    mapStyle: {
      width: ({ width }) => width || 472,
      height: ({ height }) => height || 928,
      boxSizing: "border-box"
    },
  })
);

export function GoogleMap({ onMapLoad, height, width, taskType, ...props }: GoogleMapProps) {
  const style = useStyles({ height, width });
  React.useEffect(() => {
    taskType === ERequestType.Nt || ERequestType.Msg ? initializePolylineMap(props, taskType) : initializeServices(props);
  }, [props]);

  return (
    <>
      <div className={style.mapStyle} id={props.id} />
    </>
  );
}




function initializeServices({ onMapLoad, ...props }: GoogleMapProps) {
  if (!(window as any).google) {
    return;
  }

  if (!MapService.current) {
    DirectionService.current = new (window as any).google.maps.DirectionsService();
    DirectionRenderService.current = new (window as any).google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: "#399EBF",
      }
    });
  }

  MapService.current = new (window as any).google.maps.Map(document.getElementById(props.id), props?.options);

  onMapLoad && onMapLoad(MapService.current);
  loadGoogleMap(props);
}

function initializePolylineMap({ onMapLoad, stops, options, ...props }: GoogleMapProps, taskType?: string) {
  if (!(window as any).google) {
    return;
  }

  MapService.current = new (window as any).google.maps.Map(document.getElementById(props.id), options);


  const flightPlanCoordinates = stops?.map((stop: Stop,) => {
    return {
      lat: stop?.address?.location?.latitude,
      lng: stop?.address?.location?.longitude
    }
  })


  DirectionRenderService.current = new (window as any).google.maps.Polyline({
    path: flightPlanCoordinates,
    strokeColor: taskType === ERequestType.Nt ? "#394fbf" : "#399EBF",
    strokeOpacity: 1.0,
    strokeWeight: 5,
  });

  DirectionRenderService.current.setMap(MapService.current);

  stops?.map(({ address, action }: Stop,) => {

    addMarkerCustomMarker(
      {
        lat: address?.location?.latitude,
        lng: address?.location?.longitude
      },
      action === "PICKUP" ? taskType === ERequestType.Nt ? icons().pickupNT : icons().end : action === "PICKUP_DELIVERY" ? icons().pd : taskType === ERequestType.Msg ? icons().start : icons().deleveryNT, address?.address,
      MapService.current)
  })
}

export function loadGoogleMap(props: GoogleMapProps) {
  if (MapService.current && props?.orgin && props?.destination) {
    DirectionRenderService.current?.setMap(MapService.current);
    DirectionService.current.route(
      {
        origin: { placeId: props?.orgin },
        destination: { placeId: props?.destination },
        travelMode: "DRIVING",
      },
      (response: any, status: any) => {
        if (status === "OK") {
          const leg = response.routes[0].legs[0];
          DirectionRenderService?.current?.setDirections(response);
          addMarkerCustomMarker(leg.start_location, icons().start, leg.start_address, MapService.current);
          addMarkerCustomMarker(leg.end_location, icons().end, leg.end_address, MapService.current);
        }
      }
    );
  }
}

function addMarkerCustomMarker(position: any, icon: any, title: string, map: any) {
  const marker = new (window as any).google.maps.Marker({
    position,
    map,
    icon,
    title,
  });

  const infowindow = new (window as any).google.maps.InfoWindow({
    content: `<div> ${title} </div>`,
  });

  marker.addListener("mouseover", () => {
    infowindow.open(map, marker);
  });
  marker.addListener("mouseout", () => {
    infowindow.close(map, marker);
  });
}
